import { useTranslation } from "react-i18next";

export const DEV_SAMPLE_DATA = false;
export const API_URL = process.env.REACT_APP_API_URL ?? "";
export const API_TRAVITY_URL = process.env.REACT_APP_API_TRAVITY_URL ?? "";
export const toNum = (x: any) => {
  if (!x) return 0;
  const ret = +x;
  if (isNaN(ret)) return 0;
  return ret;
};

export const getPf = (): "TAMICE" | "TRAVITY" => {
  // if (window.location.hostname.endsWith("localhost")) {
  //   return "TRAVITY";
  // }
  if (window.location.hostname.endsWith("travity.com")) {
    return "TRAVITY";
  }
  return "TAMICE";
};

export const useLangMenu = () => {
  const { t } = useTranslation();
  const languages = [
    { icon: "ko", label: t("Korean") },
    { icon: "en", label: t("English") },
    { icon: "jp", label: t("Japanese") },
    { icon: "es", label: t("Spanish") },
    { icon: "cn", label: t("Chinese") },
  ].filter((x) => {
    const pf = getPf();
    if (pf === "TRAVITY") {
      return x.icon !== "ko";
    } else if (pf === "TAMICE") {
      return x.icon === "ko";
    }
    return true;
  });
  return languages;
};
